import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

//---Models
import { Preferences } from '../../models/user/preferences';
import { User } from '../../models/user/user';


@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private router = inject(Router);


  public LOADING  = true;

  private MAIN_BALANCE : number | undefined = undefined;
  private PATRIMONY : number | undefined = undefined;
  private user : User | undefined;
  private preferences : Preferences | undefined;

  constructor() {
    this.user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') as string) : undefined;
  };

  public clear(){
    this.MAIN_BALANCE = undefined;
    this.PATRIMONY = undefined;
    this.user = undefined;
    this.preferences = undefined;
  }

  public getMainBalance() : number | undefined {
    return this.MAIN_BALANCE;
  }

  public setMainBalance(value : number) {
    this.MAIN_BALANCE = value;
  }
  public getPatrimony() : number | undefined {
    return this.PATRIMONY;
  }

  public setPatrimony(value : number) {
    this.PATRIMONY = value;
  }

  public setUserPreferences(value : Preferences) {
    this.preferences = value;
    this.setUser(this.preferences.user);
  } 

  public getUserPreferences() : Preferences | undefined {
    return this.preferences;
  }

  public getUser() : User | undefined {
    try {
      const raw = localStorage.getItem("user");
      if (!raw || raw === 'undefined' || raw === 'null') return undefined;
      return JSON.parse(raw);
    } catch {
      return undefined;
    }
  }

  public setUser(value : User | undefined) {
    this.user = value;
    if (value) {
      localStorage.setItem("user", JSON.stringify(value));
    } else {
      localStorage.removeItem("user");
    }
  }

  public getUserId() : number | undefined {
    return this.user?.idUser;
  }

  public getUserLogin() : string | undefined{
    return this.user?.login;
  }

  public getUserTitle() : string | undefined {
    return this.user?.title;
  }

  public getUserName() : string | undefined {
    return this.user?.usageName;
  }

  public getUserZipcode() : string | undefined {
    return this.user?.zipcode;
  }

  public getUserEmail() : string | undefined {
    return this.user?.email;
  }

  public getUserPhone() : string | undefined {
    return this.user?.phone;
  }

  public getUserPhoneCode() : string | undefined {
    return this.user?.phoneCode;
  }

  public getUserServiceInfo() : boolean | undefined {
    return this.user?.userDetails?.serviceInfo;
  }

  public getUserNewsletter() : boolean | undefined{
    return this.user?.userDetails?.newsletter;
  }

  public getUserCurrencyId() : string {
    const currency = this.preferences?.currency;
    if (!currency?.currencyId && localStorage.getItem("currency")) {
      return JSON.parse(localStorage.getItem("currency") as string).currencyId
    } else if (!currency?.currencyId) {
      return ""
    }
    return currency.currencyId.toString();
  }

  public setCurrencyid(currencyId : number) {
    if(this.preferences?.currency){
      this.preferences.currency.currencyId = currencyId;
    }
  }

  public getCurrency(): any | undefined {
    if (this.preferences?.currency) {
      return this.preferences.currency;
    }
    const stored = localStorage.getItem("currency");
    if (stored) {
      try {
        return JSON.parse(stored);
      } catch {
        return undefined;
      }
    }
    return undefined;
  }

  public setCurrency(currency: any): void {
    if (this.preferences) {
      this.preferences.currency = currency;
    }
    localStorage.setItem("currency", JSON.stringify(currency));
  }

  public getSimpleMode(): boolean {
    // First check if we have preferences loaded
    if (this.preferences?.simpleMode !== undefined) {
      return this.preferences.simpleMode;
    }
    
    // Fallback to localStorage
    const stored = localStorage.getItem("simpleMode");
    if (stored !== null) {
      return JSON.parse(stored);
    }
    
    // Default to true (condensed mode) for new users
    return true;
  }

  public setSimpleMode(simpleMode: boolean): void {
    // Update preferences if loaded
    if (this.preferences) {
      this.preferences.simpleMode = simpleMode;
    }
    
    // Always save to localStorage for persistence
    localStorage.setItem("simpleMode", JSON.stringify(simpleMode));
  }

  public getUserCurrencyName() : string {
    const currency = this.preferences?.currency;
    if (!currency?.name && localStorage.getItem("currency")) {
      return JSON.parse(localStorage.getItem("currency") as string).name
    } else if (!currency?.name) {
      return ""
    }
    return currency.name.toString();
  }

  public getUserCurrencySymbole() : string {
    const currency = this.preferences?.currency;
    if (!currency?.symb && localStorage.getItem("currency")) {
      return JSON.parse(localStorage.getItem("currency") as string).symb
    } else if (!currency?.symb) {
      return ""
    }
    return currency.symb.toString();
  }

}
